<template>
  <v-row
    id="gamepad"
    no-gutters
  >
    <v-col align-self="center">
      <v-btn
        v-if="isArButtonEnabled"
        dark
        :small="$vuetify.breakpoint.mdAndDown"
        :color="'#' + getGamepadButtonsColor"
        :loading="isArLoading"
        class="ml-2 mb-2"
        @click="$emit('arClick')"
      >
        {{ $localize('seeInAR') }}
      </v-btn>
    </v-col>
    <v-col
      align-self="center"
      class="d-flex flex-column align-end"
    >
      <div class="mr-2 mb-2">
        <gamepad-button
          v-if="isResetButtonEnabled"
          :color="'#' + getGamepadButtonsColor"
          icon="mdi-rotate-left"
          @click="$emit('resetClick')"
        />
        <gamepad-button
          v-if="isDimensionsButtonEnabled"
          :color="'#' + getGamepadButtonsColor"
          icon="mdi-ruler"
          @click="$emit('dimensionsClick')"
        />
        <gamepad-button
          v-if="isScreenshotButtonEnabled"
          :color="'#' + getGamepadButtonsColor"
          icon="mdi-camera-outline"
          @click="$emit('screenshotClick')"
        />
      </div>
    </v-col>
  </v-row>
</template>
<script>
  import GamepadButton from './GamepadButton.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Gamepad',

    components: {
      GamepadButton,
    },

    computed: {
      ...mapGetters([
        'getGamepadButtonsColor',
        'isArButtonEnabled',
        'isResetButtonEnabled',
        'isDimensionsButtonEnabled',
        'isScreenshotButtonEnabled',
        'isArLoading',
      ]),
    },
  }
</script>

<style scoped>
#gamepad {
  bottom: 0px;
  position: absolute;
  width: 100%;
}
</style>
